export enum AgentHarnessSocketDispatchSubject {
    GetRuntimeIdentityQuery = 'GetExtensionRuntimeIdentityStatusQuery',
    ReauthenticateRuntimeIdentityCommand = 'ReauthenticateExtensionRuntimeIdentityCommand',
    RecoverRuntimeIdentityCommand = 'RecoverExtensionRuntimeIdentityCommand',
    RevokeRuntimeIdentityCommand = 'RevokeExtensionRuntimeIdentityCommand',
    GetSettingsQuery = 'GetAgentHarnessSettingsQuery',
    GetRunsQuery = 'GetAgentRunsQuery',
    GetRunHistoryQuery = 'GetAgentRunHistoryQuery',
    GetPendingEventsQuery = 'GetAgentPendingEventsQuery',
    GetRunByIdQuery = 'GetAgentRunByIdQuery',
    GetHealthQuery = 'GetAgentHarnessHealthQuery',
    SetSettingsCommand = 'SetAgentHarnessSettingsCommand',
    CancelRunCommand = 'CancelAgentHarnessRunCommand',
    SetApplicationCircuitStateCommand = 'SetAgentApplicationCircuitStateCommand',
}

export enum AgentHarnessCommandRejectReason {
    Forbidden = 'forbidden',
    VersionConflict = 'version_conflict',
    ValidationError = 'validation_error',
    NotFound = 'not_found',
    UnsupportedCommand = 'unsupported_command',
    RateLimited = 'rate_limited',
    CommandIdConflict = 'command_id_conflict',
    InternalError = 'internal_error',
}

export enum AgentHarnessCommandSource {
    Socket = 'socket',
    Rest = 'rest',
}

export enum AgentHarnessRoomEventType {
    RunCreated = 'run_created',
    RunStatusChanged = 'run_status_changed',
    RateLimited = 'rate_limited',
    ApplicationUpdated = 'application_updated',
    GuidanceUpdated = 'guidance_updated',
    SettingsUpdated = 'settings_updated',
    ActivityProjected = 'activity_projected',
    /** The tenant runtime identity or its latest operation's delivery changed; the Runtime identity card reloads its status. */
    IdentityUpdated = 'identity_updated',
}
